import { Link } from 'react-router-dom';
import { currentStoreUrl } from '../utilities/platform';
import '../css/SiteChrome.css';

// Shared pine header band + chalk footer, matching the mobile app's screen
// anatomy: dark pine band on top, content on warm chalk, hairline-separated
// footer with legal links.

export const SiteHeader = ({ children }) => {
  return (
    <header className="ff-site-header">
      <div className="ff-site-header-inner">
        <Link to="/" className="ff-site-header-logo-link">
          <img alt="Field Facts: Baseball" className="ff-site-header-logo" src="/logo-white.svg" />
        </Link>
        <div className="ff-site-header-content">{children}</div>
      </div>
    </header>
  );
};

export const SiteFooter = () => {
  return (
    <footer className="ff-site-footer">
      <div className="ff-site-footer-inner">
        <img alt="" className="ff-site-footer-logo" src="/logo-green.svg" />
        <nav className="ff-site-footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Use</Link>
          <a href="mailto:support@fieldfactsbaseball.com">Contact Support</a>
          <a href={currentStoreUrl()}>Get the App</a>
        </nav>
        <p className="ff-site-footer-copyright">
          © {new Date().getFullYear()} Field Facts. Field data is contributed by the Field Facts community.
        </p>
      </div>
    </footer>
  );
};
